{
  "battery": "Battery",
  "depth": "Depth",
  "device": "Device",
  "flow": "Flow",
  "gps": "GPS",
  "hallSwitch": "Hall Switch",
  "hall_switch": "Hall Switch",
  "humidity": "Humidity",
  "icm": "Orientation",
  "pressure": "Pressure",
  "pressureSwitch": "Pressure Switch",
  "pressure_switch": "Pressure Switch",
  "reel": "Reel",
  "relay": "Relay",
  "temperature": "Temperature",
  "vfd": "VFD",
  "wheel": "Wheel",
  "ioExpander": "I/O Expander",
  "io_expander": "I/O Expander",
  "pivotControl": "Center Pivot",
  "center_pivot_controller": "Center Pivot"
}
